<div class="container-fluid page" *ngIf="!docDetails">

  <div class="d-flex page__box p-3 mt-2">&nbsp; Document Verification
    <div class="export_csv"><button *ngIf="documentbutton" class="clear_button_export" style="float: right;"
        (click)="openDialogexport()" mat-raised-button color="primary">Export</button></div>
  </div>
  <div class="page__content shadow p-3 ">
    <div *ngIf="selectedIndex === 1">

      <div class="row">
        <div class="col-2 topData">
          <p>Total Trader </p>
          <p style="font-size: 2rem;">{{totalTraderStaticData.totalTrader}}</p>
        </div>
        <div class="col-2 topData">
          <p>Total Verified </p>
          <p style="font-size: 2rem;">{{totalTraderStaticData.totalVerified}}</p>
        </div>
        <div class="col-2 topData">
          <p>Total Pending </p>
          <p style="font-size: 2rem;">{{totalTraderStaticData.totalPending}}</p>
        </div>

        <div class="col-3 topData">
          <p>Total Available Documents </p>
          <p style="font-size: 2rem;">{{totalTraderStaticData.totalAvailableDocuments}}</p>
        </div>
        <div class="col-3 topData">
          <p>Total Unavailable Documents </p>
          <p style="font-size: 2rem;">{{totalTraderStaticData.totalUnavailableDocuments}}</p>
        </div>
      </div>

      <div>

        <mat-card>
          <!-- <mat-card-title>
            <p style="font-size:medium;font-weight:600;">Filters: <button class="clear_button" (click)="clearFilter()" mat-raised-button color="primary">Clear Filter</button></p>
            
          </mat-card-title> -->

          <div class="example-header" *ngIf="filtershow">
            <mat-form-field class="full-width-field" style="width: 50% !important;">
              <input matInput [(ngModel)]="searchdata" (change)="changeFn($event)" placeholder="Search">
            </mat-form-field>&nbsp;&nbsp;

            <button type="submit" (click)="applyfilter(true)" class="btn btn-primary mat-primary search_bar">
              <mat-icon class="search_bar_icon">search</mat-icon>
            </button>
            <hr>
            <!-- <mat-form-field>
            <input matInput  (keyup)="filterUserDetail($event.target.value,'name')" placeholder="Name">
          </mat-form-field>&nbsp;
          <mat-form-field>
              <input matInput  (keyup)="filterUserDetail($event.target.value,'phone')" placeholder="Phone No">
            </mat-form-field>&nbsp; -->
            <mat-form-field>
              <mat-label>Status</mat-label>
              <mat-select [(ngModel)]="statusdata">
                <mat-option *ngFor="let status of statusList" [value]="status.viewValue">
                  {{status.viewValue}}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <button class="btn btn-primary mat-primary clear_button pull-right" style="margin-top: 12px;"
              (click)="clearFilter()">Clear Filter</button>&nbsp;&nbsp;

            <button type="submit" style="margin-top: 12px;margin-right: 10px !important;" (click)="applyfilter(true)"
              class="btn btn-primary mat-primary pull-right">Apply Filter </button>

            <mat-chip-list #chipList aria-label="Filter selection">
              <mat-chip *ngFor="let filter of matChipArray;let i=index" [selectable]="selectable"
                [removable]="removable" (removed)="remove(i,filter.tag)">
                {{filter.name}}
                <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon>
              </mat-chip>
            </mat-chip-list>

            <div class="text_filter_data" *ngIf="exportcsvdata">
              <p *ngIf="this.length == 0"> There's no record found with the given criteria,
                please try again refining your search and filters </p>
            </div>
            <!-- <mat-form-field>
              <input matInput  placeholder="Status">
            </mat-form-field>&nbsp; -->
            <!-- <button type="button" (click)="showViews(2)" class="btn btn-primary">Update</button> -->
          </div>

        </mat-card>

        <div class="mat-elevation-z8 position-relative" style="margin-top: 15px">
          <mat-table #table [dataSource]="dataSource" matSort>

            <!-- Name Column -->
            <ng-container matColumnDef="personName">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Person Name </mat-header-cell>
              <mat-cell *matCellDef="let userlist"><a title="View Profile" class="user_profile"
                  (click)="openDialog(userlist)">{{userlist.personName}}</a>
                <!-- <mat-icon *ngIf="userlist.isVerified==true" class="verified_icon">check_circle</mat-icon> -->
              </mat-cell>
            </ng-container>

            <!-- Weight Column -->
            <!-- <ng-container matColumnDef="role">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Role </mat-header-cell>
              <mat-cell *matCellDef="let userlist"> {{userlist.role}} </mat-cell>
            </ng-container> -->

            <ng-container matColumnDef="phoneNo">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Phone No </mat-header-cell>
              <mat-cell *matCellDef="let userlist"> {{userlist.phoneNo}} </mat-cell>
            </ng-container>

            <!-- Symbol Column -->
            <ng-container matColumnDef="documentStatus">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Status</mat-header-cell>
              <mat-cell *matCellDef="let userlist"> {{userlist.adminStatus}} </mat-cell>
            </ng-container>

            <!-- <ng-container matColumnDef="adminStatus">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Admin Status</mat-header-cell>
              <mat-cell *matCellDef="let userlist"> {{userlist.adminStatus}} </mat-cell>
            </ng-container> -->

            <ng-container matColumnDef="Address">

              <div *ngIf="restrictbutton else loading">
                <mat-header-cell *matHeaderCellDef> Document Link </mat-header-cell>
                <mat-cell *matCellDef="let userlist"><a target="_blank" class="links" style="cursor: pointer;"
                    (click)="showDocument(userlist)">{{userlist.docuements?.length == 0 ? 'Unavailable':
                    'Available'}}</a></mat-cell>
              </div>

              <ng-template #loading>
                <mat-header-cell *matHeaderCellDef> Document Link </mat-header-cell>
                <mat-cell *matCellDef="let userlist"><a class="links">Unavailable</a></mat-cell>
                <!-- <mat-cell *matCellDef="let userlist"><a class="links"  style="cursor: pointer;" (click)="showDocument(userlist)">{{userlist.docuements?.length == 0 ? 'Unavailable': 'Available'}}</a></mat-cell> -->
              </ng-template>


              <!-- <ng-container *ngIf="docdisable">
                <mat-cell *matCellDef="let userlist"><a class="links" (click)="showDocument(userlist)">View Document</a> </mat-cell>
              </ng-container>
              <ng-container *ngIf="!docdisable">
                <mat-cell *matCellDef="let userlist"><a>No Document</a></mat-cell>
              </ng-container> -->
            </ng-container>

            <ng-container matColumnDef="verificationHistory">
              <mat-header-cell *matHeaderCellDef mat-sort-header> Verification History </mat-header-cell>
              <mat-cell *matCellDef="let userlist"><a class="links" target="_blank" style="cursor: pointer;"
                  (click)="versionHistory(userlist)">View</a>
                <!-- <mat-icon *ngIf="userlist.isVerified==true" class="verified_icon">check_circle</mat-icon> -->
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
          </mat-table>

          <div>
            <mat-paginator [length]="length" [pageIndex]="pageIndex" [pageSizeOptions]="[10,20,50,100]"
              (page)="getServerData($event)" showFirstLastButtons aria-label="">
            </mat-paginator>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="container-fluid page" *ngIf="docDetails">
  <div class="d-flex page__box p-3 mt-2"><img src="./assets/arrow_logo.png" class="arrow"
      (click)="docList()">&nbsp;&nbsp;Document Verification</div>
  <div class="galleryImgScroll">
    <div id="col-1">
      <div style="width:100%">
        <div>
          <gallery class="custom" id="basic-test" fluid [items]="items_find_url" style="width:60%;">
          </gallery>
        </div>
      </div>
      <div *ngIf="filetypereal == '.pdf'">
        <div *ngFor="let video of pdfprint">
          <!-- <div class='iframe-parent'>
          </div> -->
        </div>
      </div>
    </div>

    <div>
      <div id="col-2">
        <mat-card style="border-radius: 21px;">
          <div class="col-md-12 row" style="justify-content: space-between !important">
            <div class="col-md-4 document">
              <!-- <h5>Document Details</h5> -->
              <p class="name_field">
                <!--<b>Person Name</b>    :--> {{personName == null ? 'NA':personName}}
              </p>
              <p style="font-size:17px !important;font-weight:600;">
                <!--<b>Role</b>           :--> {{companyname == null ? 'company name not available':companyname}}
              </p>
              <p>
                {{states == null ? 'State not available':states}},{{district == null ? 'District not
                available':district}}</p>

            </div>
            <div class="col-md-4" style="margin-top: 30px;">
              <!-- <p><b>Role</b>           : <b>{{companyname == null ? 'NA':companyname}}</b></p> -->
              <p>
                {{phoneNo == null ? 'Phone no not available':phoneNo}}
              </p>
              <p>
                {{emailId == null ? 'Email id not available':emailId}}
              </p>
              <!-- <p><b>Mandi</b>          : <b>{{mandi == null ? 'Email Id not available':mandi}}</b></p> -->
            </div>
            <div class="col-md-4">
              <p>
                <!--<b>Document Staus</b> :--> {{documentStatus == 'InProgress' ? 'verification
                pending':documentStatus}}
              </p>
              <p *ngIf="documentStatus == 'Rejected'">Reason for Rejection: {{rejectedReason}}</p>
              <mat-icon *ngIf="documentStatus == 'Verified'" class="maticonverify">check_circle</mat-icon>

              <div *ngIf="restrictbutton">
                <div
                  *ngIf="documentStatus == 'InProgress' || documentStatus == 'Rejected' || documentStatus == 'Pending Verification'">
                  <button type="button" style="width: 50%; border-color: #0d6efd; background-color: #2b50a0; "
                    (click)="Updateverified('verify')" class="btn btn-primary">Approve</button>
                </div>
                <!-- <div style="margin-top: 8px;"> -->
                <div
                  *ngIf="documentStatus == 'InProgress' || documentStatus == 'Verified' || documentStatus == 'Pending Verification'">
                  <button type="button" (click)="rejectionInput('open')"
                    class="btn btn-primary rejbutt">Reject</button>&nbsp;
                </div>
                <div>
                  <form>

                    <mat-form-field style="width: 80%;" *ngIf="showinput">
                      <mat-label>Reason for rejection</mat-label>
                      <mat-select [(ngModel)]="ReasonForReject" name="rejection">
                        <mat-option *ngFor="let reject of resonForReject" [value]="reject.viewValue">
                          {{reject.viewValue}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </form>
                </div>

                <div *ngIf="ReasonForReject==='Others'">

                  <textarea type="text" placeholder="Mention a reason" [(ngModel)]="otherReasonText" maxlength="100"
                    rows="3" style="width: 80%;"></textarea>

                </div>
                <button *ngIf="showinput" type="button" style="background-color: #9CC43C;
                  border-color: #0d6efd;" (click)="Updateverified('reject')" class="btn btn-primary">Submit</button>
                &nbsp;
                <button *ngIf="otherReason" (click)="rejectionInput('close')" class="btn btn-primary" type="button"
                  style="background-color: #9CC43C;
                  border-color: #0d6efd;"> Cancel</button>
              </div>
            </div>

          </div>
        </mat-card>

      </div>
    </div>

  </div>
  <!-- <app-document-history [userDataItem]=userDataList></app-document-history> -->
</div>
